import auth_required from './hooks/auth_required';
import preloaderHook from './hooks/preloader-hook';

import Home from '@/views/Home.vue';
import Storybook from '@/views/dev/Storybook.vue';
import TranslationTest from '@/views/dev/TranslationTest.vue';

const Report = () => import('@/views/Report.vue');

import cookies from '@/utils/cookies';

import desktopViewForced from '@/routes/hooks/desktop-view-forced';
import filterService from '@/services/filter';

const mode = 'history';

const filtersHook = (to: any, from: any, next: Function) => {
  filterService.set();
  next();
};

const hashHook = (to: any, from: any, next: Function) => {
  if (mode === 'history' && to.hash) {
    if (to.hash.includes('login/member')) {
      const index = to.hash.indexOf('login/member');
      next(to.hash.slice(index));
    } else {
      next();
    }
  } else {
    next();
  }
};

const referralHook = (to: any, from: any, next: Function) => {
  if (to.query.ref) {
    cookies.set('referralId', to.query.ref);
    next('/register');
  } else {
    next();
  }
};

const pageOnlyForDevelopment = (to: any, from: any, next: Function) => {
  if (import.meta.env.MODE === 'development') {
    return next();
  }

  return next(false);
};

export default [
  {
    path: '',
    name: 'app.blank',
    beforeEnter: [
      auth_required,
      hashHook,
      filtersHook,
      preloaderHook,
      referralHook,
      desktopViewForced,
    ],
    //@ts-ignore
    component: Home,
    meta: {
      menuType: 'dashboard',
      pageTitle: 'Home',
    },
  },
  {
    path: '/dev/storybook',
    name: 'dev.storybook',
    beforeEnter: pageOnlyForDevelopment,
    component: Storybook,
    meta: {
      menuType: 'storybook',
      pageTitle: 'Storybook',
    },
  },
  {
    path: '/dev/translations',
    name: 'dev.translations',
    beforeEnter: pageOnlyForDevelopment,
    component: TranslationTest,
    meta: {
      menuType: 'translationTest',
      pageTitle: 'TranslationTest',
    },
  },
  {
    path: '/app/dashboard/:data',
    name: 'app.index',
    beforeEnter: [auth_required, preloaderHook, desktopViewForced],
    //@ts-ignore
    component: Home,
    meta: {
      menuType: 'dashboard',
      pageTitle: 'Home',
    },
  },
  {
    path: '/app/report/:type/:data/:report?',
    name: 'app.report',
    beforeEnter: [auth_required, filtersHook, desktopViewForced],
    //@ts-ignore
    component: Report,
    meta: {
      pageTitle: 'Report',
    },
  },
  // {
  //   path: '/app/sixth-sense/:data',
  //   name: 'app.sixth_sense',
  //   beforeEnter: auth_required,
  //   //@ts-ignore
  //   component: SixthSense
  // },
  {
    path: '/app/conversions/:data/:report?',
    name: 'app.conversions',
    beforeEnter: [auth_required, filtersHook, desktopViewForced],
    //@ts-ignore
    component: Report,
    meta: {
      pageTitle: 'Report conversions',
    },
  },
  {
    path: '/app/postbacks/:data/:report?',
    name: 'app.postbacks',
    beforeEnter: [auth_required, filtersHook, desktopViewForced],
    //@ts-ignore
    component: Report,
    meta: {
      pageTitle: 'Report postbacks',
    },
  },
  {
    path: '/app/live-visits/:data/:report?',
    name: 'app.live-visits',
    beforeEnter: [auth_required, filtersHook, desktopViewForced],
    //@ts-ignore
    component: Report,
    meta: {
      pageTitle: 'Report live visits',
    },
  },
  {
    path: '/app/live-clicks/:data/:report?',
    name: 'app.live-clicks',
    beforeEnter: [auth_required, filtersHook, desktopViewForced],
    //@ts-ignore
    component: Report,
    meta: {
      pageTitle: 'Report live clicks',
    },
  },
  {
    path: '/app/errors/:data/:report?',
    name: 'app.errors',
    beforeEnter: [auth_required, filtersHook, desktopViewForced],
    //@ts-ignore
    component: Report,
    meta: {
      pageTitle: 'Report errors',
    },
  },
];
